import { render, staticRenderFns } from "./BigContactCTA.vue?vue&type=template&id=25875b0f&scoped=true&"
import script from "./BigContactCTA.vue?vue&type=script&lang=ts&"
export * from "./BigContactCTA.vue?vue&type=script&lang=ts&"
import style0 from "./BigContactCTA.vue?vue&type=style&index=0&id=25875b0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25875b0f",
  null
  
)

export default component.exports